import Styles from './EmptyPreview.module.scss'
import { ReactComponent as EmptyFolderIcon } from './emptyfolder.svg'
import cx from 'classnames'

interface Props {
  className?: string
}

export const EmptyFolder = ({ className }: Props) => (
  <div className={cx(Styles.empty, className)}>
    <EmptyFolderIcon />
    <div className={Styles.emptyText}>This Project is empty</div>
  </div>
)
